<template>
    <div class="video">
        <video id="cover-video" controls preload="true" poster="@/assets/imgs/video_cover.png"
               webkit-playsinline="true"
               playsinline="true" class="video-js vjs-big-play-centere" data-setup="{}">
            <source src="https://res.cloudinary.com/kiubixdev/video/upload/v1533320365/gxsv/intro_01.mp4"
                    type="video/mp4">
            Your browser does not support HTML5 video.
        </video>
        <!--<canvas id="canvas-video"></canvas>-->
    </div>
</template>

<script>

    import videojs from 'video.js'
    import 'video.js/dist/video-js.min.css'

    export default {
        name: 'video-component',
        mounted() {
            window.v = this;
            videojs(document.querySelector('#cover-video'))
                .ready(function () {
                    console.log('Ready')
                        const video = document.querySelector('#cover-video');

                        window.v.$root.$on('video:init', () => {
                            this.currentTime(0);
                            this.play()
                        });

                        this.on('ended', () => {
                            window.v.$router.push('/usar-el-cinturon');
                        });

                        video.addEventListener('ended', () => {
                            window.v.$root.$off('video:init');
                            window.v.$router.push('/usar-el-cinturon');
                        });

                        window.v.$root.$on('video:stop', () => {
                            this.currentTime(0);
                            this.pause();
                        });

                        if (window.v.$route.path === '/' && window.v.$store.state.api_token) {
                            this.play();
                        } else {
                            this.pause();
                        }
                    }
                )
        },
        data() {
            return {
                video: null
            }
        },
        methods: {
            resize(canvas, h, w) {
                canvas.style.height = (h + 'px');
                canvas.style.width = (w + 'px');
            },
            draw(video, ctx, canvas) {
                if (video.paused || video.ended) return false;
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                setTimeout(() => {
                    this.draw(video, ctx, canvas)
                }, 1000 / 50);
            }
        },
        destroyed() {
            this.$root.$off('video:init');
            this.$root.$off('video:stop');
            this.$root.$off('video:playing');
            this.$root.$off('video:ended');
            videojs('cover-video').reset()
        }
    };
</script>

<style lang="sass" scoped>
    .video
        top: 0
        bottom: 0
        right: 0
        left: 0
        position: fixed
        .video-js
            height: 100%
            width: 100%
            background-color: transparent !important
            video
                /*display: none*/
                min-width: 100%
                min-height: 100%
                width: auto
                height: auto
                position: absolute
                top: 50%
                left: 50%
                -webkit-transform: translate(-50%, -50%)
                -ms-transform: translate(-50%, -50%)
                transform: translate(-50%, -50%)
                max-width: 100%
                max-height: 100%
            .vjs-big-play-button
                top: 50% !important
                left: 50% !important
                transform: translate(-50%, -50%) !important
                font-size: 5em !important
                height: 2em !important

</style>
